import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 400);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (!visible) return null;

    return (
        <button
            onClick={scrollToTop}
            style={{ bottom: 'calc(1.5rem + var(--sticky-cta-height, 0px))' }}
            className="fixed right-6 z-40 w-10 h-10 bg-[#CEAC8F] text-black rounded-full flex items-center justify-center shadow-lg hover:bg-[#d4b896] transition-all hover:scale-110"
            aria-label="Back to top"
        >
            <ChevronUp className="w-5 h-5" />
        </button>
    );
};

export default BackToTop;